import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import Filter from './Filter';
import ServiceTabs from './ServiceTabs';

const SummaryTitle = ({
  selectedDate,
  handleDateRangeChange,
  handleResetFilter,
  isNewUIAppDetail,
  activeServiceTab,
  onTabChange,
}) => {
  const { t } = useTranslation();

  if (!isNewUIAppDetail) {
    return (
      <div className="summary-title">
        <Typography
          className="summary-title-text"
          variant="body-20-bold"
          color={COLOR.label2[100]}
        >
          {t('summaryTitle')}
        </Typography>
        <Filter
          selectedDate={selectedDate}
          handleDateRangeChange={handleDateRangeChange}
          handleResetFilter={handleResetFilter}
        />
      </div>
    );
  }

  return (
    <div className="summary-title-wrapper">
      <div className="summary-title-header">
        <Typography
          className="summary-title-text"
          variant="body-20-bold"
          color={COLOR.label2[100]}
        >
          {t('summaryTitle')}
        </Typography>
      </div>
      <div className="summary-tabs-filter-row">
        <ServiceTabs activeTab={activeServiceTab} onChange={onTabChange} />
        <Filter
          selectedDate={selectedDate}
          handleDateRangeChange={handleDateRangeChange}
          handleResetFilter={handleResetFilter}
        />
      </div>
    </div>
  );
};

export default SummaryTitle;
